import { useState, useEffect } from "react";

const useMobile = (size:number) => {

    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
      function handleResize() {
        setIsMobile(window.innerWidth < size)
      }
      window.addEventListener("resize", handleResize);
      handleResize();
      return () => window.removeEventListener("resize", handleResize);
    }, [size]);
    return isMobile;
}

export default useMobile;